import { Banner, Text } from '@kluein/klue-ui';
import { Overlay } from '@mantine/core';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useNetworkStatus from 'hooks/use-network-status/useNetworkStatus';
import TEST_IDS from 'test-ids';

const OFFLINE_BANNER_HEIGHT = '46px';
const OVERLAY_Z_INDEX_PLUS_ONE = 201;

const OfflineBanner = () => {
  const isOnline = useNetworkStatus();
  const { t } = useTranslation(['Common']);
  const [isDismissed, setIsDismissed] = useState<boolean>(false);

  // Reset dismissed state when coming back online
  useEffect(() => {
    if (isOnline) {
      setIsDismissed(false);
    }
  }, [isOnline]);

  if (isOnline) {
    return null; // Don't render the banner if online
  }

  const handleOnDismiss = () => {
    setIsDismissed(true);
  };

  return isDismissed ? null : (
    <>
      <Banner
        dataTestId={TEST_IDS.layout.offlineBanner.container}
        variant="global"
        showIcon
        show
        height={OFFLINE_BANNER_HEIGHT}
        status="warning"
        style={{ zIndex: OVERLAY_Z_INDEX_PLUS_ONE }}
        onClose={handleOnDismiss}
        closeLabel="Dismiss"
      >
        <Text>{t('Common:offlineMessage')}</Text>
      </Banner>
      <Overlay blur={5} style={{ top: OFFLINE_BANNER_HEIGHT }} />
    </>
  );
};

export default OfflineBanner;
